/**
 * Brühmenge = Wasseraufwand/ha * Fläche / 10000
 * @param fieldWasseraufwand
 * @param realWasseraufwand
 * @param fieldFlaeche
 * @param fieldBrueheEinfach
 */
window.calcBrueheEinfachEdit = function(fieldWasseraufwand, realWasseraufwand, fieldFlaeche, fieldBrueheEinfach) {
    const bruehmenge = parseFloat($(realWasseraufwand).val()) * parseFloat($(fieldFlaeche).val()) / 10000;
    $(fieldBrueheEinfach).val(phpRound(bruehmenge, 3));
};

/**
 * Wasseraufwand/ha = Brühmenge / Fläche * 10000
 * @param fieldWasseraufwand
 * @param realWasseraufwand
 * @param fieldFlaeche
 * @param fieldBrueheEinfach
 */
window.calcWasseraufwandEdit = function(fieldWasseraufwand, realWasseraufwand, fieldFlaeche, fieldBrueheEinfach) {
    const wasseraufwand = parseFloat($(fieldBrueheEinfach).val()) / parseFloat($(fieldFlaeche).val()) * 10000;
    $(realWasseraufwand).val(phpRound(wasseraufwand, 5));
    $(fieldWasseraufwand).val(phpRound(wasseraufwand, 1));
};

/**
 * checkBruehmengeEditOpen
 * @param sectionID
 * @returns {boolean}
 */
window.checkBruehmengeEditOpen = function(sectionID) {
    const tableBerechnungBruehmenge = $('#table-berechnungBruehmenge');
    const checkedData = tableBerechnungBruehmenge.find('input[name=select-section]:checked');

    if (checkedData.length > 1) {
        ajaxDialog(BASE_PATH + 'ajax/dialog/betriebsdaten/ajax.editWasseraufwandHa', 300, {post_data: {data: getCheckedData(tableBerechnungBruehmenge.find('input[name=select-section]:checked'))}});
    } else {
        window.location = BASE_PATH + 'betriebsdaten/berechnungBruehmengeEdit/' + sectionID;
    }

    return false;
};